export function stringToEnum<T extends Record<string, string | number>>(
  enumObj: T,
  value: string,
): T[keyof T] | undefined {
  return (Object.values(enumObj) as string[]).includes(value) ? (value as T[keyof T]) : undefined;
}
